import type { PageErrorDevModeProps } from "./page-error-dev-mode.type";

import "./page-error-dev-mode.style.less";
import { isAPIError } from "@/modules/error-boundary";

const devModeTitle = "🤖 Unexpected application Error!";

const PageErrorDevMode = ({ error }: PageErrorDevModeProps) => {
  if (isAPIError(error)) console.error(error.response);

  return (
    <div className="page-error-dev-mode">
      <h1>{devModeTitle}</h1>
      {error instanceof Error && (
        <>
          <h2>{error.message}</h2>
          <pre>{error.stack}</pre>
        </>
      )}
      {isAPIError(error) && error.response?.data?.message ? (
        <pre>{error.response.data.message}</pre>
      ) : null}
    </div>
  );
};

export default PageErrorDevMode;
